import { gql } from "@apollo/client";

export interface Def_MutationResponse {
  code: string;
  success: boolean;
  message: string;
}

export interface CreateResetPasswordEntry {
  username: string;
}

export interface TokenResetPassword {
  token: string;
  password: string;
}
export interface CreateResetResponse {
  app: {
    resetPassword: Def_MutationResponse; 
  }
}

export const CREATE_RESET_PASSWORD_ENTRY = gql`
  mutation ResetPassword($token: String!, $password: String!) {
    app {
      resetPassword(token: $token, password: $password) {
        code
        success
        message
      }
    }
  }
`;
export interface TokenResetResponse {
  app: {
    createResetPasswordToken: Def_MutationResponse;
  }
}

export const TOKEN_RESET_PASSWORD = gql`
  mutation CreateResetPasswordToken($username: String!) {
    app {
      createResetPasswordToken(username: $username) {
        code
        success
        message
      }
    }
  }
`